import React, { useState, useRef, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import axios from "axios";
import Table from "react-bootstrap/Table";
import loading1 from "../../assets/img/loading-gif.gif";
import loadingwithdraww from "../../assets/img/loading-gif.gif";
import Swal from "sweetalert2";
import Tab from "react-bootstrap/Tab";
import $ from "jquery";
import { fetchwalletamount } from "../../common.js";
import { Spinner } from "react-bootstrap";
import { Container } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { GiWallet } from "react-icons/gi";

import { Button, Form, Input, message, Space, Modal } from "antd";
import Withdrawhistory from "./Withdrawhistory.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoArrowBackSharp } from "react-icons/io5";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { use } from "react";
export default function WithdrawPage() {
  const navigate = useNavigate();
  const [walletAmount, setWalletAmount] = useState(null);
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };
    const isAdmined = localStorage.getItem("isAdmin");
    const userTokened = localStorage.getItem("userToken");
    useEffect(() => {
    
      if (!userTokened  || !isAdmined === "false") {
        navigate("/");
        localStorage.clear();
      }
    }, [!isAdmined]);
  const Navigatehome = () => {
    navigate("/");
  }
  const [usernameError, setUsernameError] = useState(null);
  const [username, setUsername] = useState("");
  const [selectedOption, setSelectedOption] = useState(true);
  const [userProfile, setUserProfile] = useState(null);
  const [amountvalue, setvalue] = useState("");
  const [users, setUsers] = useState([]);
  const [user, setUsers1] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [userData, setUserData] = useState(null);
  const [appmanager, setAppmanager] = useState({ min_deposit: 0 });
  const [totalSuccessAmount, settotalSuccessAmount] = useState(0);
  const [minredeem, setMinredeem] = useState(null);
  const [Deposit, setDeposit] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [winamount, setwinamount] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loadingwithdraw, setLoadingwithdraw] = useState(false);
  const [loadingwallet, setLoadingwallet] = useState(false);
  const [msg, setmsg] = useState("");
  const [msgwallet, setmsgwallet] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const isButtonLoading = useRef(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [loadingbutton, setLoadingbutton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [valueswithdraw, setValueswithdraw] = useState([]);
  const [balance, setBalance] = useState(null);
  const [selectedBanks, setSelectedBanks] = useState({
    bankId: "",
    bankName: "",
    ifscCode: "",
    accountNumber: "",
    accountHolderName: "",
  });
  const [filteredValues1, setFilteredValues1] = useState([]); // Store filtered bank list
  const [bankNames, setBankNames] = useState("");
  const userid = localStorage.getItem("userid");
  const changevalue = (e) => {
    setvalue(e.target.value);
  };
  // const handleButtonClickdeposit = (amount) => {
  //   // setSelectedAmount(amount);
  //   setInputValuedeposit(amount);
  // };
  const handleButtonClickdeposit = (amount) => {
    setInputValuedeposit((prevValue) => {
      const newValue = prevValue ? parseInt(prevValue) + parseInt(amount) : parseInt(amount);
      return newValue.toString();
    });
  };
  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const [form] = Form.useForm();

  const onFinish = () => {
    // message.success('Submit success!');
  };

  const onFinishFailed = () => {
    message.error("Submit failed!");
  };

  useEffect(() => {
    loaduser1();
  }, []);


  const [paginate, setpaginate] = useState(1);
  const [loadbuttonshow, setloadbuttonshow] = useState();
  let firstNumbers = [];

  const shoot = () => {
    // loaduser();
  };

  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL_NODE}user/user-profile`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: userid }),
        });

        const data = await response.json();
        if (data.success === 1) {

          setBalance(data.user.balance); // Set balance in state
        } else {
          console.error("Error:", data.message);
        }
      } catch (err) {
        setError("Failed to fetch user profile");
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [userid]);

  const [userName, setUserName] = useState("");

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await fetch(`https://api.Cash365days.in/user/user-profile`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: userid }),
        });

        const data = await response.json();
        if (data.success === 1) {

          setUserName(data.user.userName); // Set balance in state
        } else {
          console.error("Error:", data.message);
        }
      } catch (err) {
        setError("Failed to fetch user profile");
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [userid]);

  const loaduser1 = async () => {
    const userid = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");
    setLoadingwithdraw(true);
    let url = `https://api.Cash365days.in/user/user-transaction-history/${userid}`;
    // let url = `${process.env.REACT_APP_API_URL_NODE}user/user-transaction-history/${userid}`;


    var config = {
      method: "get",
      url: url
    };
    axios
      .get(url, config)
      .then(function (response) {
        const res = JSON.stringify(response.data);
        setUsers(response.data.transactions);

        const msg = response.data.message;
        var winamount = response.data.winAmount;
        setwinamount(winamount);
        if (res != undefined) {
          const objectRes = JSON.parse(res);

        }
        const withdrawTransactions = response.data.transactions.filter(
          (transaction) => transaction.type === "Withdraw"
        );
        console.log(withdrawTransactions)
        const totalSuccessAmount = withdrawTransactions
          .filter((transaction) => transaction.status === "Success" || transaction.status === "Pending")
          .reduce((acc, transaction) => acc + transaction.amount, 0);
        console.log(totalSuccessAmount)

        settotalSuccessAmount(totalSuccessAmount)
      })
      .finally(() => {
        setLoadingwithdraw(false);
      });
  };

  const user_id = localStorage.getItem("userid");
  const dev_id = localStorage.getItem("dev_id");
  const [inputValuedeposit, setInputValuedeposit] = useState("");

  const handleAdd = () => {
    if (!inputValuedeposit || inputValuedeposit < 100) {
      Swal.fire({
        icon: "error",
        title: "Invalid Amount",
        text: "Amount must be minimum 100!",
      });
      return;
    }

    navigate("/PaymentType", { state: { amount: inputValuedeposit } });
  };

  const handleDeposit = async () => {
    if (!inputValuedeposit || isNaN(inputValuedeposit) || inputValuedeposit <= 0) {
      toast.error("Please enter a valid deposit amount!");
      return;
    }

    const requestData = {
      userId: user_id, // Replace with dynamic user ID if available
      amount: parseFloat(inputValuedeposit),
      bankId: selectedBanks.bankId,
      bankName: selectedBanks.bankName,
      ifscCode: selectedBanks.ifscCode,
      accountNumber: selectedBanks.accountNumber,
      accountHolderName: selectedBanks.accountHolderName,
    };

    try {
      setLoading(true);

      if (requestData.bankId == '' || requestData.bankName == '' || requestData.ifscCode == '' || requestData.accountNumber == '' || requestData.accountHolderName == '') {
        setLoading(false);
        toast.error("Please select a bank!");
        return;
      }

      const response = await fetch(`https://api.Cash365days.in/user/deposit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      if (data.success == 1) {
        setLoading3(false);
        setIsButtonDisabled(true);
        Swal.fire({
          title: data.message,
          icon: 'success',
          timer: 2000
        }).then((result) => {
          // navigate(0);
          loaduser1();
        });
      } else {
        Swal.fire({
          title: data.message,
          timer: 3000,
          icon: 'error'
        });
      }

    } catch (error) {
      console.error("Error during deposit:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };




  // Withdrawal Api
  const [bankName, setBankName] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [otp, setotp] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [inputError, setInputError] = useState(false);
  const [bankNameError, setBankNameError] = useState(false);
  const [accountHolderNameError, setAccountHolderNameError] = useState(false);
  const [accountNumberError, setAccountNumberError] = useState(false);
  const [ifscCodeError, setIfscCodeError] = useState(false);
  const [otpError, setotpError] = useState(false);
  const [mobilnumbererror, setMobileNumberError] = useState(false);
  const [amounttrerror, setAmountError] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [accountHolderNameBank, setAccountHolderNameBank] = useState("");
  const [accountNumberBank, setAccountNumberBank] = useState("");
  const [accountNumberBank1, setAccountNumberBank1] = useState("");
  const [ifscCodeBank, setIfscCodeBank] = useState("");
  const [filteredValues, setFilteredValues] = useState([]);
  const [showList, setShowList] = useState(true);
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [timer, setTimer] = useState(60);
  const [confirmAccountNumberError, setConfirmAccountNumberError] = useState(false);

  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const intervalRef = useRef(null);

  const [bankList, setBankList] = useState([]);

  const [selectedBank, setSelectedBank] = useState(null);

  const inputRef = useRef(null);



  const fetchBankData = async () => {
    try {
      const user_id = localStorage.getItem("userid");

      if (!user_id) {
        throw new Error("User ID not found in local storage.");
      }

      setLoadingwithdraw(true);

      const url = `https://api.Cash365days.in/user/get-bank-details/${user_id}`;
      const response = await axios.get(url); // Using async/await

      if (response.status !== 200) {
        throw new Error(`Unexpected response status: ${response.status}`);
      }

      const bankDetails = response.data.normalbankDetails;

      if (!bankDetails) {
        throw new Error("Bank details not found in the response.");
      }

      console.warn("Fetched Bank Details:", bankDetails);

      // Update state
      setBankName(bankDetails.bankName || "N/A");
      setAccountHolderName(bankDetails.accountHolderName || "N/A");
      setAccountNumber(bankDetails.accountNumber || "N/A");
      setIfscCode(bankDetails.ifscCode || "N/A");

    } catch (error) {
      console.error("Error fetching bank details:", error.message);
    } finally {
      setLoadingwithdraw(false);
    }
  };

  // const handleBankSelection = (bank) => {
  //   setSelectedBank(bank);
  //   setBankName(bank.bankName);
  //   setAccountHolderName(bank.accountHolderName);
  //   setAccountNumber(bank.accountNumber);
  //   setIfscCode(bank.ifscCode);
  //   setShowList(false);
  // };


  useEffect(() => {
    fetchBankData();
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  const handleClicksend = () => {
    if (!isButtonClicked) {
      setIsButtonClicked(true);
      handleWithdrawal();
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        clearInterval(intervalRef.current);
        setIsButtonClicked(false);
      }, 3000);
    }
  };


  const handleWithdrawal = async () => {
    // if (totalSuccessAmount > balance) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Insufficient Balance",
    //     text: "The withdrawal amount cannot exceed the available wallet balance.",
    //   });
    //   return;
    // }

    // if (!inputValue || inputValue < 100) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Invalid Amount",
    //     text: "The minimum withdrawal amount is 100!",
    //   });
    //   return;
    // }
    try {
      setLoadingbutton(true);
      const errors = [];
      setInputError(false);
      setBankNameError(false);
      setAccountHolderNameError(false);
      setAccountNumberError(false);
      setIfscCodeError(false);

      const amountPattern = /^\d+(\.\d{1,2})?$/;
      const bankNamePattern = /^[A-Za-z\s]+$/;
      const accountHolderNamePattern = /^[A-Za-z\s]+$/;
      const accountNumberPattern = /^\d+$/;
      const ifscCodePattern = /^[A-Za-z\s\d]+$/;

      if (!selectedBanks.bankName.match(bankNamePattern)) {
        setBankNameError(true);
        errors.push('Please enter a valid bank name (letters and spaces only)');
      }


      if (!selectedBanks.accountNumber.match(accountNumberPattern)) {
        setAccountNumberError(true);
        errors.push('Please enter a valid account number (8-18 digits)');
      }

      if (!selectedBanks.accountHolderName.match(accountHolderNamePattern)) {
        setAccountHolderNameError(true);
        errors.push('Please enter a valid account holder name (letters and spaces only)');
      }

      if (!selectedBanks.ifscCode.match(ifscCodePattern)) {
        setIfscCodeError(true);
        errors.push('Please enter a valid IFSC code (e.g., ABCD1234567)');
      }
      if (!inputValue.match(amountPattern)) {
        setInputError(true);
        errors.push('Please enter a valid amount (e.g., 500 or 500.00)');
      }
      if (errors.length > 0) {

        const errorMessage = errors.join('\n');
        console.error(errorMessage);
        return;
      }
      const usernameRegex = /^[a-zA-Z0-9_]{5,20}$/;
      if (!userName || !usernameRegex.test(userName)) {
        setUsernameError(true);
        Swal.fire({
          icon: "error",
          title: "User Name",
          text: "Username must be 5-20 characters and can only contain letters, numbers, and underscores.",
        });
        return;
      } else {
        setUsernameError(false);
      }
      const user_id = localStorage.getItem("userid");
      const requestData = {
        userId: user_id,
        amount: parseInt(inputValue),
        accountHolderName: selectedBanks.accountHolderName,
        bankName: selectedBanks.bankName,
        accountNumber: selectedBanks.accountNumber,
        ifscCode: selectedBanks.ifscCode,
        userName: userName
      };

      const url = `https://api.Cash365days.in/user/withdraw`;
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      };

      const response = await fetch(url, config);
      const data = await response.json();
      if (data.success == 1) {
        setLoading3(false);
        setIsButtonDisabled(true);
        Swal.fire({
          title: data.message,
          icon: 'success',
          timer: 2000
        }).then((result) => {
          // navigate(0);
          loaduser1();
          setBankName('');
          setAccountHolderName('');
          setAccountNumber('');
          setIfscCode('');
          setInputValuedeposit('');
          setSelectedBanks('')
          setUsername('')

        });
      } else {
        Swal.fire({
          title: data.message,
          timer: 3000,
          icon: 'error'
        });
      }
    } catch (error) {
      console.error('Error handling withdrawal:', error);
    } finally {
      setLoadingbutton(false);
    }
  };


  const handleButtonClick = (amount) => {
    setInputValue((prevValue) => {
      const newValue = prevValue ? parseInt(prevValue) + parseInt(amount) : parseInt(amount);
      return newValue.toString();
    });
  };

  const [mobilnumber, setmobilNumber] = useState("");
  const [amounttr, setAmounttr] = useState("");

  useEffect(() => {
    if (valueswithdraw) {
      setFilteredValues(
        valueswithdraw.filter(
          (item) =>
            item.bank_name &&
            bankName &&
            item.bank_name.toLowerCase().includes(bankName.toLowerCase())
        )
      );
    }
  }, [bankName, valueswithdraw]);

  // bankName list api

  useEffect(() => {
    const getBankList = async () => {
      try {
        const url = `https://api.Cash365days.in/user/get-bank-details/${user_id}`;

        const response = await fetch(url);
        const data = await response.json();

        const adminBanks = data.bankDetails?.filter(bank => bank.type === "user" && bank.status === "1") || [];

        setFilteredValues1(adminBanks);
      } catch (error) {
        console.error("Error fetching bank details:", error);
      }
    };

    getBankList();
  }, []);

  // Handle bank selection
  const handleBankSelect = (e) => {
    const selectedBankName = e.target.value;
    const selectedBankData = filteredValues1.find(bank => bank._id === selectedBankName);

    if (selectedBankData) {
      setSelectedBanks({
        bankId: selectedBankData._id,
        bankName: selectedBankData.bankName,
        ifscCode: selectedBankData.ifscCode,
        accountNumber: selectedBankData.accountNumber,
        accountHolderName: selectedBankData.accountHolderName,
      });
    } else {
      setSelectedBanks({
        bankId: "",
        bankName: "",
        ifscCode: "",
        accountNumber: "",
        accountHolderName: "",
      });
    }
  };

  return (
    <>
      <section id="wallet" className="margin-bottom-88 mt-0 walletdesign_all">
        <div className="backbuttonall d-flex justify-content-between align-items-center">
          <div className="backbutton" onClick={() => Navigatehome()}>
            <IoArrowBackSharp />
          </div>
          <div className="pagetitle">
            <span>Withdraw</span>
          </div>
          <div className="walletamt d-flex align-items-center">
            <div className="iconwallwt">
              <GiWallet />
            </div>
            <p>Withdraw <span></span> </p>
          </div>
        </div>
        <Container fluid className="p-0 margin-bottom-70">
          <div className="homecontainer">
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey="first"
              className="w-100"
            >
              <div className="">
                <div className="tabs_wallet">
                  {/* <Nav variant="pills" className="tabslinks">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="first"
                        className="text-center AddPoint"
                      >
                        Deposit
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="second"
                        className="text-center Withdraw"
                      >
                        Withdraw
                      </Nav.Link>
                    </Nav.Item>
                  </Nav> */}
                </div>
              </div>
              <div>
                {/* Withdraw section */}

                <div className="tab_content_one position-relative">
                  <div className="addfundwallet">
                    <div className="bankicon">
                      <Icon.Bank />
                    </div>
                    <input
                      type="Number"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      className={`form-control forminputdesign  ${inputError ? "is-invalid" : ""
                        } addamountinput`}
                      placeholder="Withdraw amount"
                    />
                    {inputError && (
                      <div className="invalid-feedback">
                        Please enter a valid amount (e.g., 500 or 500.00)
                      </div>
                    )}
                  </div>
                  <div className="button-amount d-flex flex-wrap">
                    <button
                      className="btn-amount"
                      onClick={() => handleButtonClick("500")}
                    >
                      ₹ 500
                    </button>
                    <button
                      className="btn-amount"
                      onClick={() => handleButtonClick("1000")}
                    >
                      ₹ 1000
                    </button>
                    <button
                      className="btn-amount"
                      onClick={() => handleButtonClick("2500")}
                    >
                      ₹ 2500
                    </button>
                    <button
                      className="btn-amount"
                      onClick={() => handleButtonClick("5000")}
                    >
                      ₹ 5000
                    </button>
                    <button
                      className="btn-amount"
                      onClick={() => handleButtonClick("7500")}
                    >
                      ₹ 7500
                    </button>
                    <button
                      className="btn-amount"
                      onClick={() => handleButtonClick("10000")}
                    >
                      ₹ 10000
                    </button>

                  </div>
                  <div className="bank_bankdetails">
                    <div className="deposittitle">
                      <p className="mb-0">
                        Bank Account Details
                      </p>
                    </div>
                    <div>


                      <button className='btn btn-secondary labelform mb-2' onClick={() => navigate('/add-bank')}>
                        Add Bank Account
                      </button>


                      <Form name="basic"
                        labelCol={{
                          span: 24,
                        }}
                        wrapperCol={{
                          span: 24,
                        }}
                        layout="horizontal"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        className="position-relative formbankdetails"
                      >

                        <div className="transactiondesign_form">
                          <div className="selection w-100">
                            <select onChange={handleBankSelect} className="form-select">
                              <option value="">Select a Bank</option>
                              {filteredValues1.map((bank) => (
                                <option key={bank._id} value={bank._id}>
                                  {bank.bankName}
                                </option>
                              ))}
                            </select>

                          </div>
                        </div>
                        <Form.Item
                          className="mb-2 labelform"
                          label="User Name"
                          rules={[{ required: true, message: "Username is required!" }]}
                        >
                          <Input
                            placeholder="Enter Name"
                            value={userName}
                            // onChange={(e) => setUsername(e.target.value)}
                            readOnly
                            className={`form-control forminputdesign ${usernameError ? "is-invalid" : ""}`}
                          />
                          {usernameError && (
                            <div className="invalid-feedback">
                              Username must be 5–20 characters and only contain letters, numbers, and underscores.
                            </div>
                          )}
                        </Form.Item>
                        <Form.Item
                          className="labelform mb-2"
                          label="Bank Name"
                          rules={[{ required: true }]}>
                          <Input
                            type="text"
                            placeholder="Bank Name"
                            disabled
                            value={selectedBanks.bankName}
                            onChange={(e) => {
                              setBankName(e.target.value);
                            }}

                            className={`form-control forminputdesign  ${bankNameError ? "is-invalid" : ""}`}
                          />

                        </Form.Item>

                        <Form.Item className="labelform mb-2"
                          label="Account Holder Name"
                          rules={[
                            { required: true },
                            { pattern: /^[a-zA-Z\s]*$/, message: 'Only letters and spaces are allowed' },
                            { type: 'string' }
                          ]}
                        >

                          <Input
                            type="text"
                            placeholder="Account Holder Name"
                            value={selectedBanks.accountHolderName}
                            onChange={(e) => setAccountHolderName(e.target.value)}
                            disabled
                            className={`form-control forminputdesign  ${accountHolderNameError ? 'is-invalid' : ''}`}
                          />
                          {accountHolderNameError && (
                            <div className="invalid-feedback">Please enter a valid account holder name (letters and spaces only)</div>
                          )}
                        </Form.Item>

                        <Form.Item
                          className="labelform mb-2"
                          label="Account Number"
                          rules={[{ required: true }, { type: 'string' }]}
                        >
                          <Input
                            type="text"
                            placeholder="Account Number"
                            value={selectedBanks.accountNumber}
                            onChange={(e) => {
                              const input = e.target.value.replace(/\D/g, '');
                              const limitedInput = input.slice(0, 18);
                              setAccountNumber(limitedInput);
                            }}
                            disabled
                            className={`form-control forminputdesign  ${accountNumberError ? 'is-invalid' : ''}`}
                          />
                          {accountNumberError && (
                            <div className="invalid-feedback">Please enter a valid account number (numbers only)</div>
                          )}
                        </Form.Item>

                        <Form.Item
                          className="labelform mb-2"
                          label="IFSC Code"
                          rules={[{ required: true }, { type: 'uri', warningOnly: true }, { type: 'string' }]}
                        >
                          <Input
                            type="text"
                            placeholder="IFSC Code"
                            value={selectedBanks.ifscCode}
                            onChange={(e) => {
                              const input = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
                              const limitedInput = input.slice(0, 20);
                              const upperCaseInput = limitedInput.toUpperCase();
                              setIfscCode(upperCaseInput);
                            }}
                            disabled
                            className={`form-control forminputdesign  ${ifscCodeError ? 'is-invalid' : ''}`}
                          />
                          {ifscCodeError && (
                            <div className="invalid-feedback">Please enter a valid IFSC code (e.g., ABCD1234567)</div>
                          )}
                        </Form.Item>


                        {isButtonVisible ? (
                          <Form.Item>
                            <Button disabled={isButtonClicked || loadingbutton} type="" htmlType="submit" className=' withdrawbutton' onClick={handleClicksend}>
                              Withdrawal
                              {loadingbutton && <Spinner animation="border" style={{ marginLeft: '5px', width: '15px', height: '15px', marginTop: "15px" }} />}
                            </Button>

                          </Form.Item>
                        ) : (
                          <div className="d-flex justify-content-center position-relative" style={{ left: '0' }}>
                            <img src={loadingwithdraww} className="px-2 loaderfile" style={{ width: '50px' }} />
                          </div>
                        )}
                      </Form>
                    </div>
                  </div>
                </div>
                <div className="deposittitle">
                  <p className="mb-0">
                    Withdraw History
                  </p>
                </div>
                <div className="table-responsive">

                  <Table
                    striped
                    bordered
                    hover
                    className="table_deposit position-relative"
                  >
                    <thead>
                      <tr>
                        <th>S No</th>
                        <th>Pay Mode</th>
                        <th>Date</th>
                        <th>Points </th>
                        {/* <th>Closing Balance </th> */}
                        <th>Status </th>
                        <th>Reason</th>
                      </tr>
                    </thead>
                    <tbody className="tbodyhistroy">
                      {users.length > 0 ? (
                        users &&
                        users?.filter((value) => value.type === "Withdraw").map((value, index) => {
                          const dateTime = new Date(value.created_at);
                          const formattedDate = `${dateTime.getDate()}-${dateTime.getMonth() + 1
                            }-${dateTime.getFullYear()} ${dateTime.getHours()}:${dateTime.getMinutes()}`;
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {value.remark} {value.market}
                              </td>
                              <td>{new Date(value.createdAt).toLocaleDateString()}</td>
                              <td>{value.amount}</td>
                              {/* <td>{value.balance}</td> */}
                              <td className="text-success">
                                {" "}
                                <span
                                  style={{
                                    color:
                                      value.status === "Success"
                                        ? "green"
                                        : value.status === "Pending"
                                          ? "orange"
                                          : "red",
                                  }}
                                >
                                  {value.status}
                                </span>
                              </td>
                              <td style={{ maxWidth: "100px" }}>
                                <div className="scroll">{value.reason}</div></td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan="10"
                            className="text-center nodataavl"
                          >
                            {" "}
                            No data available or something went wrong.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {loadingwithdraw && (
                      <div className="loadernew">
                        <img
                          src={loading1}
                          className="px-2 loaderfile"
                          style={{ width: "50px" }}
                          alt="Loading..."
                        />
                      </div>
                    )}
                  </Table>
                </div>
              </div>
            </Tab.Container>
          </div>
        </Container>
        <ToastContainer />
      </section>
      {loading2 && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}
      {loading3 && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}
    </>
  );
}
